module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- Document meta form Modal -->\n<div class="modal fade" id="addMetaModal" tabindex="-1" role="dialog" aria-labelledby="addMetaModal">\n    <div class="modal-dialog modal-lg" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="addMetaModalLabel">'+
((__t=( (metadataId ? 'Edit metadata' : 'Add metadata') ))==null?'':__t)+
'</h4>\n            </div>\n            <div class="modal-body">\n                <div id="document-meta-form"></div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" id="save">Save</button>\n            </div>\n        </div>\n    </div>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/document-meta-modal.html
// module id = 397
// module chunks = 0